import type { UserId } from "@nimble/datamodel/types/userId";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getJobAlerts } from "@/lib/api-clients/candidate-api-client";

export type GetJobAlertsResponse = Awaited<ReturnType<typeof getJobAlerts>>;

export function getJobAlertsQueryKey(userId: UserId) {
  return ["job-alerts", userId] as const;
}

export function useGetJobAlerts(
  userId: UserId,
  options?: Omit<UseQueryOptions<GetJobAlertsResponse>, "queryKey" | "queryFn">,
) {
  return useQuery({
    queryKey: getJobAlertsQueryKey(userId),
    queryFn: () => getJobAlerts(userId),
    ...options,
  });
}
